// http://tobiasahlin.com/spinkit/

angular.module('cfn').directive('cfnSpinner', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: require('./cfnSpinner.html')
  };
});
